<template>
    <div class="qualityTracingManage">
       <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "qualityTracingManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
